import { createSlice } from "@reduxjs/toolkit";
import {
  TypesCreatePixelAction,
  TypesDeletePixelAction,
  TypesPixel,
  TypesUpdatePixelAction,
} from "../types/audiencePixels";
import AudiencePixels from "../Services/audience_pixels";
import { toast } from "react-toastify";
import I18n from "Services/i18n";
import { AppThunk } from "../store/configureStore";

interface IPixelsState {
  loading: boolean;
  data: TypesPixel[];
  errors: any;
}

const initialState: IPixelsState = {
  loading: false,
  data: [],
  errors: {},
};

const audiencePixelsSlice = createSlice({
  name: "pixels",
  initialState,
  reducers: {
    setLoader: (state) => {
      state.loading = true;
      state.errors = initialState.errors;
    },
    setData: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.data = payload;
    },
    setError: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.errors = payload;
    },
  },
});

const { setLoader, setData, setError } = audiencePixelsSlice.actions;

export const loadPixels = (): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const data = await AudiencePixels.load();
    dispatch(setData(data));
  } catch (error) {
    dispatch(setError(error));
  }
};

export const createPixel: TypesCreatePixelAction = (
  addAudienceId,
  delAudienceId,
  status
): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    await AudiencePixels.create(addAudienceId, delAudienceId, status);
    dispatch(loadPixels());
    toast.success(I18n.getStringByKey("toast_success-audience-pixel-created"));
  } catch (error) {
    dispatch(setError(error));
    toast.error(I18n.getStringByKey("toast_error-audience-pixel-create"));
  }
};

export const updatePixel: TypesUpdatePixelAction = (
  uid,
  addAudienceId,
  delAudienceId,
  status
): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    await AudiencePixels.update(addAudienceId, delAudienceId, uid, status);
    dispatch(loadPixels());
    toast.success(I18n.getStringByKey("toast_success-audience-pixel-updated"));
  } catch (error) {
    dispatch(setError(error));
    toast.error(I18n.getStringByKey("toast_error-audience-pixel-update"));
  }
};

export const deletePixel: TypesDeletePixelAction = (
  uid,
  addAudienceId,
  delAudienceId
): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    await AudiencePixels.delete(addAudienceId, delAudienceId, uid);
    dispatch(loadPixels());
    toast.success(I18n.getStringByKey("toast_success-audience-pixel-deleted"));
  } catch (error) {
    dispatch(setError(error));
    toast.error(I18n.getStringByKey("toast_error-audience-pixel-delete"));
  }
};

export default audiencePixelsSlice.reducer;
